/**
 * Unified Supabase exports
 * This file provides access to both client and server configurations
 */

// Client-side exports (safe for browser)
export { createClient, supabase } from './client'

// Server-side exports (only use in server context)
// Note: Don't import server functions in client-side code


// Helper to determine if we're in a server context
export const isServer = typeof window === 'undefined'